import React, { memo } from 'react';
import PropTypes from 'prop-types';

import paths from 'app/paths';
import { ViewLinkButton } from 'components';

const AccessLogActionsCell = memo((props) => {
  const {
    item: { id },
  } = props;
  return <ViewLinkButton to={paths.accessLogView.path} params={{ id }} />;
});

AccessLogActionsCell.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

export default AccessLogActionsCell;
